// extracted by mini-css-extract-plugin
export default {"base":"vp_VUE9o","wrapper":"vp_w1kmm","bottom":"vp_uG23u","pinned":"vp_RmmRo"};